var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footerBar"},[_c('span',{staticClass:"footer__text"},[_vm._v(" © True Software Scandinavia AB")])])}]

export { render, staticRenderFns }